import * as React from 'react';

const Tag = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-564-232h2000V968H-564z" />
            <g transform="translate(-20 -14)">
                <rect width={302.5} height={46.5} x={0.75} y={0.75} stroke="#E6E9EB" strokeWidth={1.5} rx={23.25} />
                <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    transform="translate(20.833 14.833)"
                >
                    <path d="M.05 1.3v5.214a2.5 2.5 0 0 0 .732 1.768l9.635 9.635a1.25 1.25 0 0 0 1.767 0l5.733-5.734a1.25 1.25 0 0 0 0-1.767L8.282.782A2.5 2.5 0 0 0 6.516.05H1.301C.61.05.05.61.05 1.3" />
                    <circle cx={4.426} cy={4.425} r={1.25} />
                </g>
            </g>
        </g>
    </svg>
);
export default Tag;
